<template>
    <div>
        <event-write-link v-for="writeLayout in writeLayouts" :key="`eventWrite${writeLayout}`"
                             :writeLayout="writeLayout" :eventData="eventData"></event-write-link>
    </div>
</template>

<script>
import eventUtil from "@/components/event/eventUtil";
import EventValidator from "@/mixins/validators/EventValidator";
import EventWriteLink from "@/components/event/EventWriteLink";
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import alertMixins from "@/mixins/alertMixins";
import ApiFileUpload from "@/mixins/ApiFileUpload";
export default {
    name: "EventWriteComponent",
    mixins: [ eventUtil, EventValidator, alertMixins, ApiFileUpload ],
    components: {
        EventWriteLink
    },
    provide() {
        return {
            eventWriteSetData: this.setData,
            eventWriteToggleShowStatus: this.toggleShowStatus
        }
    },
    inject: [],
    props: {
        eventType: {default: '',},
        eventKey: {default: 0},
    },
    data() {
        return{
            getFunc: '',
            detailApiParamSet: {},
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            parsingData: {},
            allSetData: false,
            fileInfo: [],
            directUrl: '',
            directType: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            fileUploadFailMsg: '',
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,
            isRunning: false,
            eventData: {},
        }
    },
    created(){
        this.initFilterConfig();
        if (this.eventKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getEvent();
        }
    },
    mounted() {
        EventBus.$on('writeEvent', this.writeEvent)
        EventBus.$on('eventDelete', this.runDelete)
    },
    beforeDestroy() {
        EventBus.$off('writeEvent')
        EventBus.$off('eventDelete')
    },
    computed: {
    },
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig() {
            let config = this.returnEventConfig(this.eventType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnEventConfig(this.eventType);
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.allSetData = config.allSetData;
            this.fileInfo = config.fileInfo;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;
            this.deleteFunc = config.deleteFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.keyName = config.keyName;
            this.newDeleteClass();
        },
        getEvent() {
            let params = Object.assign({}, this.detailApiParamSet);
            params.id = this.eventKey;
            try {
                this.$api.$event[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type != 1 || util.isEmpty(res.List)) {
                        this.errorAlert({
                            content:'상세를 가져올 수가 없습니다.',
                        })
                        this.$router.back();
                        return false;
                    }
                    this.eventData = res.List[0];
                    this.initTemplateConfig();
                })
            }catch (e) {
                console.log(e)
            }
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$event[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDelete(key, moreParams) {
            // EventBus.$emit('changeLoading', true);
            console.log('test!!!', key, moreParams)
            this.DeleteClass.runDelete(key, moreParams)
        },
        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },
        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
            return this.$validate(validatorArr).then(success => {
                if(!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                util.Array.each(this.fileInfo, (fileInfo, index, arr) => {
                    if(success && fileInfo.required && util.isEmpty(this[fileInfo.fileName])) {
                        this.errorAlert(fileInfo.validatorMsg)
                        success = false;
                    }
                })
                return success;
            })

        },
        _makeParams() {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                if(paramKey != '' && (this.allSetData || this.eventData[paramKey] != this[dataKey])) {
                    params[paramKey] = this[dataKey];
                }
            })
            if(!util.isEmpty(this.eventKey) && this.eventKey != 0) {
                params[this.keyName] = this.eventKey;
            }
            return params;
        },
        async writeEvent() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator();
            if(!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();
            try {
                this.$api.$event[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if(type === true) {
                        let key = res.List;
                        if(this.eventKey != 0) {
                            key = this.eventKey;
                        }
                        this.runApiUploadFiles(this.fileInfo, key).then(res => {
                            this.afterFunc(key);
                        })
                    }else{
                        this.errorAlert(type);
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    }
                })
            }catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
        returnWriteType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type]
            }
        },
        afterFunc() {
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.getEvent();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    EventBus.$emit('changeLoading', false)
                    let url = this.directUrl;
                    this.$router.push(url);
                }
            })
        },
        toggleShowStatus(display=0) {
            if(this.eventKey == 0) {
                return;
            }
            let params = {
                e_is_display: display,
                e_idx: this.eventKey,
            };
            try {
                this.$api.$event.updateEvent(params).then(res => res.Data.Result).then(res => {
                    let type = this.toggleShowStatusReturnType(res.Info.Type);
                    if(type === true) {
                        this.eventData.e_is_display = display;
                    }else{
                        this.createAlert({
                            content: type,
                            btnText: '확인',
                        });

                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
        toggleShowStatusReturnType(type) {
            switch (type) {
                case 1:
                    return true;
                case -2:
                    return '권한이 없습니다.';
                default:
                    return '등록에 실패했습니다. 노출기간을 확인해주세요.';
            }
        },
    },
    watch: {
    },
}
</script>

<style scoped>

</style>
